// hooks
import { useAppSelector } from '../store/hooks'
// state
import { AppState } from '../store/index'
// types
import type { I_Notification } from '../interfaces'

export function useGetAllNotifications(): Array<I_Notification> {
  return useAppSelector((state: AppState) => state.notifications.items)
}

export function useGetNotificationsStatus() {
  return useAppSelector((state: AppState) => state.notifications.status)
}
